/*
 * Copyright (C) 2018 Spanning Cloud Apps LLC.  All rights reserved.
 */

/*
 * This module provides access to the alert event management functions of the server.
 */
angular
  .module('services.alertEvents', ['http.alertEvents'])
  .factory('AlertEventService', ['$q', '$rootScope', 'httpAlertEvents', factory]);

/**
 * The factory that creates the service.
 */
function factory($q, $rootScope, httpAlertEvents) {
  // Cache of alert events by batch id
  const eventsByBatch = {};

  // Expose the functions only, not the data
  return {
    getEventsForBatch
  };

  /**
   * Returns the alert events for a batch.
   *
   * @param {number} batchId - the id of the backup batch.
   * @param {boolean} refresh - if true ignore the cache and always call the server.
   * @returns {Promise<object[]>} the promise of the list of alert events.
   */
  function getEventsForBatch(batchId, refresh) {
    var events = eventsByBatch[batchId];
    if (events && !refresh) {
      return $q.when(events);
    }

    $rootScope.showLoadingMask = true;
    return httpAlertEvents
      .getEventsForBatch(batchId)
      .then((events) => {
        eventsByBatch[batchId] = events;
        return events;
      })
      .finally(() => {
        $rootScope.showLoadingMask = false;
      });
  }
}
